import { render, staticRenderFns } from "./AlterarImagem.vue?vue&type=template&id=258b6f24"
import script from "./AlterarImagem.vue?vue&type=script&lang=ts"
export * from "./AlterarImagem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports